// extracted by mini-css-extract-plugin
module.exports = {"codeEditorIcons":"CodeEditorIcons_codeEditorIcons__1B5Ys","settingsIcon":"CodeEditorIcons_settingsIcon__3ueJ-","tagIcon":"CodeEditorIcons_tagIcon__3pMtp"};